import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=70ec442e&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=70ec442e&scoped=true&lang=css"
import style1 from "./NavigationMenu.vue?vue&type=style&index=1&id=70ec442e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec442e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ec442e')) {
      api.createRecord('70ec442e', component.options)
    } else {
      api.reload('70ec442e', component.options)
    }
    module.hot.accept("./NavigationMenu.vue?vue&type=template&id=70ec442e&scoped=true", function () {
      api.rerender('70ec442e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/NavigationMenu.vue"
export default component.exports